import React from 'react';
export function Footer() {
  return <footer className="bg-[#1a1a1a] text-white/60 py-12 px-4 text-center text-sm" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        <div className="text-white font-serif font-bold text-xl mb-4 flex items-center justify-center gap-2" data-id="element-65">
          <span data-id="element-66">🧘‍♀️</span> YOGA PRONTA
        </div>

        <p className="mb-8 text-white/50" data-id="element-67">un progetto di EduLabs Italia</p>

        <div className="flex flex-wrap items-center justify-center gap-6 mb-8" data-id="element-68">
          <a href="#" className="hover:text-white transition-colors" data-id="element-69">
            Privacy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-70">
            Termini
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-71">
            Contatti
          </a>
        </div>

        <p data-id="element-72">&copy; 2026 EduLabs Italia — Tutti i diritti riservati.</p>
      </div>
    </footer>;
}